import type { LucideIcon } from 'lucide-react';
import {
  AppWindow,
  Armchair,
  AudioLines,
  BedDouble,
  BedSingle,
  Blinds,
  Box,
  CheckCircle2,
  Circle,
  DoorClosed,
  DoorOpen,
  Gauge,
  Grid3x3,
  GripVertical,
  Headphones,
  Layers,
  Library,
  Mic,
  Monitor,
  Pencil,
  RectangleHorizontal,
  Shirt,
  SlidersHorizontal,
  Sofa,
  Sparkles,
  Speaker,
  Square,
  Triangle,
  Volume2,
  VolumeX,
  Warehouse,
  Waves,
  Zap,
} from 'lucide-react';

/**
 * String-to-LucideIcon lookup so data files can stay POJO (`icon: 'mic'`)
 * while components resolve the actual React component at render time.
 *
 * Keep entries alphabetical; new palette objects / recommendation kinds
 * need a row here if their icon isn't already listed.
 */
export const ICON_BY_NAME: Record<string, LucideIcon> = {
  'app-window': AppWindow,
  armchair: Armchair,
  'audio-lines': AudioLines,
  'bed-double': BedDouble,
  'bed-single': BedSingle,
  blinds: Blinds,
  box: Box,
  'check-circle-2': CheckCircle2,
  'door-closed': DoorClosed,
  'door-open': DoorOpen,
  gauge: Gauge,
  'grid-3x3': Grid3x3,
  'grip-vertical': GripVertical,
  headphones: Headphones,
  layers: Layers,
  library: Library,
  mic: Mic,
  monitor: Monitor,
  pencil: Pencil,
  'rectangle-horizontal': RectangleHorizontal,
  shirt: Shirt,
  'sliders-horizontal': SlidersHorizontal,
  sofa: Sofa,
  sparkles: Sparkles,
  speaker: Speaker,
  square: Square,
  triangle: Triangle,
  'volume-2': Volume2,
  'volume-x': VolumeX,
  warehouse: Warehouse,
  waves: Waves,
  zap: Zap,
};

/**
 * Resolve an icon by name, falling back to a neutral Circle when the
 * name is missing or not in the map. Never throws — UIs that show a
 * placeholder circle fail gracefully if a data file introduces a new
 * icon before the map is updated.
 */
export function lookupIcon(name: string | undefined | null): LucideIcon {
  if (!name) return Circle;
  return ICON_BY_NAME[name] ?? Circle;
}
